// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IEnvironment } from '../app/core/interfaces';

export const environment: IEnvironment = {
  version: '1.2.3s',
  production: false,
  // Don't change anything here before reading scripts/enable-dev-environment.js.
  // localhost is the default
  apiUrl: 'https://proflyt-api-dev-pithp4flaq-uc.a.run.app',
  clientUrl: 'https://dev-proflyt.web.app',
  firebaseConfig: {
    apiKey: 'AIzaSyAJNAusRWBSxrvsTxyqTvmUjoRzUX1OSxM',
    authDomain: 'dev-proflyt.firebaseapp.com',
    databaseURL: 'https://dev-proflyt.firebaseio.com',
    projectId: 'dev-proflyt',
    storageBucket: 'dev-proflyt.appspot.com',
    messagingSenderId: '95979882571',
    appId: '1:95979882571:web:562c6bf65abed85d9d65ce',
    measurementId: 'G-6JZ68N1JWV',
  },
  pusherKey: '2892232f074cd30b3ab9',
  pusherCluster: 'us2',
  sentryConfiguration: {
    dsn: 'https://0df2ebc971da4679856f2356541b0452@sentry.devsec.ybox.dev/2',
    tracingOrigins: ['localhost', 'dev-proflyt.web.app'],
    tracesSampleRate: 1.0,
  },
  appIdentifier: 'com.ProFlyt.ProFlyt',
  iosAppId: '1548088693',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
